// export const BACKEND_BASE = "http://localhost:8000"; // local FastAPI server (direct)
// export const BACKEND_BASE = "http://localhost:8118"; // local web server
export const BACKEND_BASE = "https://bravokilo.ch"; // deployed web server
